import PropTypes from 'prop-types';
import React from 'react';

import BackgroundImage from '$partials/media/background-image';
import Link from '$partials/global/link';
import { formatUrlWithActiveFund } from '$utilities/format';

const PersonItem = ({
    className = '',
    jobTitle,
    linkedinUrl,
    listingImage,
    companiesByPersonAsFounder,
    openToModal = false,
    itemsAreClickable,
    title,
    style,
    twitterUrl,
    url: originalUrl,
}) => {
    const Component = !itemsAreClickable ? 'div' : openToModal ? Link : 'a';
    const url = formatUrlWithActiveFund(originalUrl);

    return (
        <div className={`expand-interaction ${className}`}>
            <div
                className='aspect-2/3 overflow-hidden relative rounded-lg'>
                {listingImage ? (
                    <BackgroundImage
                        containerClassName=''
                        {...listingImage} />
                ) : (
                    <div className='bg-dark-grey h-full w-full' />
                )}
            </div>
            <div className='mt-20 md:mt-40'>
                <h3 className='type-style-5'>
                    <Component
                        className={'expand-interaction__action'}
                        href={`${itemsAreClickable ? url : ''}`}>
                        {title}
                    </Component>
                </h3>
                {jobTitle &&
                    <p className='mt-5'>
                        {jobTitle}
                    </p>
                }
                {companiesByPersonAsFounder?.edges[0]?.node?.title &&
                    <p>
                        {companiesByPersonAsFounder.edges[0].node.title}
                    </p>
                }
            </div>

            {/* Share Links */}
            {style !== 'carousel' && (
                <div className='flex mt-15 mb-20 md:mb-40 type-style-8'>
                    {linkedinUrl && (
                        <>
                            <a
                                className=''
                                href={linkedinUrl}
                                rel='noreferrer noopener'
                                target='_blank'>
                                {'LinkedIn'}
                            </a>
                            {twitterUrl && (
                                <span>&nbsp;·&nbsp;</span>
                            )}
                        </>
                    )}
                    {twitterUrl && (
                        <>
                            <a
                                className=''
                                href={twitterUrl}
                                rel='noreferrer noopener'
                                target='_blank'>
                            X
                            </a>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    jobTitle: PropTypes.string,
    linkedinUrl: PropTypes.string,
    listingImage: PropTypes.object,
    listingText: PropTypes.string,
    openToModal: PropTypes.bool,
    itemsAreClickable: PropTypes.bool,
    title: PropTypes.string,
    twitterUrl: PropTypes.string,
    url: PropTypes.string,
    style: PropTypes.string,
    companiesByPersonAsFounder: PropTypes.object,
};

PersonItem.propTypes = propTypes;

export default PersonItem;
